/**
 * @React
 */
import React, {
    useEffect,
    useState,
    useMemo,
    createContext,
    useContext
} from 'react';

/**
 * @Hooks
 */
import { useFetchData } from 'hooks';
/**
 * @Utils
 */
import { generateUrl } from 'utilities/generateRequestUrl';
import config from 'utilities/generateRequestUrl/config';
/**
 * @Types
 */
import {
    MonitoringValues,
    TransformedData
} from 'types';
enum endpoints_enum {
    GETGENERALINFO = 'getGeneralInfo',
}
export interface GeneralInfoContextType {
    options: TransformedData | null;
    setOptions: React.Dispatch<React.SetStateAction<TransformedData | null>>;
    generatedValues: MonitoringValues | null;
    setGeneratedValues: React.Dispatch<React.SetStateAction<MonitoringValues | null>>;
    data: { options: TransformedData, values: MonitoringValues } | null;
    load: boolean;
    error: string | null;
}
const GeneralInformationContext = createContext<GeneralInfoContextType | undefined>(undefined);
const GeneralInformationContextProvider: React.FC = ({ children }) => {
    const [options, setOptions] = useState<TransformedData | null>(null);
    const [generatedValues, setGeneratedValues] = useState<MonitoringValues | null>(null);
    const { data, load, error } = useFetchData<{ options: TransformedData, values: MonitoringValues } | null>(generateUrl(config.client, endpoints_enum.GETGENERALINFO, null, null));

    useEffect(() => {
        if (data) {
            const { options, values } = data as { options: TransformedData, values: MonitoringValues };
            setOptions(options);
            setGeneratedValues(values);
        }
    }, [data]);

    const contextValue = useMemo(() => ({
        options,
        setOptions,
        generatedValues,
        setGeneratedValues,
        data,
        load,
        error,
    }), [options, setOptions, generatedValues, setGeneratedValues, data, load, error]);

    return (
        <GeneralInformationContext.Provider value={contextValue}>
            {children}
        </GeneralInformationContext.Provider>
    );
};
export const useGeneralInfoContext = () => {
    const context = useContext(GeneralInformationContext);
    if (!context) {
        throw new Error('useMyContext must be used within a MyContextProvider');
    }
    return context;
};

export default GeneralInformationContextProvider;
